import styled from 'styled-components'
import { themeMedia } from '../../../styles/theme'

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1rem;
`

export const StyledTitleWrapper = styled.div`
  p {
    font-size: 20px;
  }
  margin-bottom: 20px;

  ${themeMedia.desktop`
      p {
        font-size: 22px;
      } 
  `}
`

export const StyledDescriptionWrapper = styled.div`
  p {
    font-size: 14px;
  }
  margin-bottom: 30px;

  ${themeMedia.desktop`
      p {
        font-size: 17px;
      } 
  `}
`
